import { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from '../hooks/useReducedMotion';
import { cx } from './cx';

export function CountUp({ value, duration = 900, className }) {
  const reduced = useReducedMotion();
  const [display, setDisplay] = useState(reduced ? value : 0);
  const currentRef = useRef(reduced ? value : 0);

  useEffect(() => {
    if (reduced) {
      currentRef.current = value;
      setDisplay(value);
      return undefined;
    }
    const from = currentRef.current;
    if (from === value) return undefined;
    const startedAt = performance.now();
    let frame = 0;
    const tick = (now) => {
      const progress = Math.min(1, (now - startedAt) / duration);
      const eased = 1 - (1 - progress) ** 4;
      const next = Math.round(from + (value - from) * eased);
      currentRef.current = next;
      setDisplay(next);
      if (progress < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [value, duration, reduced]);

  return <span className={cx('count-up', className)}>{display}</span>;
}
